var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/_html.js
// module id = ../../node_modules/core-js/modules/_html.js
// module chunks = 18